
// 繁体中文
const chinese = {
    limit_sales: '限時下殺',
    unit: 'NT$',
    saled: '件已售',
    service: [
        '支援711超商',
        '7天鑒賞期',
        '免郵費'
    ],
    paymentType: [
      {
        name: '貨到付款',
        value: 0
      },
      {
        name: '711超商取貨',
        value: 1
      },
      {
        name: '全家取貨',
        value: 2
      },
    ],
    detail: '商品詳情',
    buynow: '立即下單',
    choice: '商品選擇：',
    ordered: '已訂購：',
    goodsImage: '商品图片',
    goodsName: '商品名称',
    goodsAttr: '商品属性',
    total: '商品合計：',
    payment: '付款方式：',
    clientName: '姓名',
    mobile: '手機',
    // mobileError: '電話號碼格式不對',
    mobilePlaceholder: '請輸入您的手機號碼',
    area: '地區',
    address: '詳細地址',
    addressPlaceholder: 'xx路xx號',

    email: 'E-mail',
    emailPlaceholder: '填寫常用的郵箱',
    postal: 'Postal',
    postalPlaceholder: '郵政編碼',
    message: '留言',
    messagePlaceholder: '如有額外需求請留言',
    note: '用戶須知',
    confirm: '確認提交',

    // 订单结果页
    goback: '返回首頁',
    kefu: '客服',
    success: '下單成功',
    orderTime: '訂單時間',
    orderId: '訂單編號',
    shouhuo: '收貨信息',
    packageNum: '套餐數量',
    totalPrice: '商品合計',
    yunfei: '運費',
    shifu: '實付',
    sevenDay: '7天鑒賞期',

    // 表单错误提示
    missingValue: '请埴写此项',
    lengthError: '长度错误',
    mismatch: '请输入正确的格式',
    numberMismatch: '请输入数字',

    // 提交太频繁
    'too fast': '提交过于频繁，请稍后再试'
}

// 英语
const english = {
    limit_sales: 'Time-limited Discount',
    unit: 'RM',
    saled: 'pieces sold',
    service: [
      '7-day Appreciation Period',
      'Postage free',
    ],
    paymentType: [
      {
        name: 'Cash on delivery',
        value: 0
      }
    ],
    detail: 'Product Information',
    buynow: 'Order now',
    choice: 'Selection：',
    ordered: 'Ordered：',
    goodsImage: 'pictures',
    goodsName: 'name',
    goodsAttr: 'attribute',
    total: 'Total：',
    payment: 'Payment method：',
    clientName: 'Name',
    clientNamePlaceholder: 'Please enter name',
    mobile: 'Mobile',
    mobileError: 'Please enter the correct phone number',
    mobilePlaceholder: 'Please enter phone number',
    area: 'province',
    address: 'Address',
    addressPlaceholder: '(Ex. Apt no. Building Name, Room#.)',

    email: 'E-mail',
    emailPlaceholder: '',
    postal: 'Postal',
    postalPlaceholder: '',
    message: 'Note',
    messagePlaceholder: 'Leave a message',
    note: 'policy',
    confirm: 'Submit',

    // 订单结果页
    goback: 'Home',
    kefu: 'Service online',
    success: 'Success',
    orderTime: 'Date',
    orderId: 'Order ID',
    shouhuo: 'Address',
    packageNum: 'Package Quantity',
    totalPrice: 'Total',
    yunfei: 'Freight',
    shifu: 'Pay',
    sevenDay: 'Seven days appreciation period',

    // 表单错误提示
    missingValue: 'Please write this column.',
    lengthError: 'Length Error',
    mismatch: 'Not Match',
    numberMismatch: 'Enter numbers only',
    

    // 提交太频繁
    'too fast': 'Submit too fast, please try again later'
}

// 泰语
const thai = {
    limit_sales: 'โปรโมชันจำกัด เวลา',
    unit: '฿',
    saled: ' ขายแล้ว',
    service: [
        'สินค้าเปลี่ยนหรือคืนได้ 7วัน',
        'รวมค่าขนส่ง',
    ],
    paymentType: [
      {
        name: 'เงินสดในการส่งมอบ',
        value: 0
      }
    ],
    detail: 'รายละเอียดสินค้า',
    buynow: 'รีบซื้อเลย',
    choice: 'เลือกสินค้า：',
    ordered: 'ได้สั่ง：',
    goodsImage: 'รูปภาพสินค้า',
    goodsName: 'ชื่อสินค้า',
    goodsAttr: 'แอตทริบิวต์',
    total: 'ยอดเงิน：',
    payment: 'วิธีการชําระเงิน：',
    clientName: 'ชื่อ',
    clientNamePlaceholder: 'กรุณากรอกชื่อของคุณ',
    mobile: 'เบอร์มือถือ',
    mobileError: 'กรุณาใส่เบอร์โทรศัพท์ที่ถูกต้องให้ครบ 10 หลัก',
    mobilePlaceholder: 'กรุณากรอกหมายเลขโทรศัพท์ของคุณ',
    area: 'จังหวัด',
    address: 'ที่อยู่',
    addressPlaceholder: 'กรุณากรอกรายละเอียดที่อยู่',

    email: 'E-mail',
    emailPlaceholder: '',
    postal: 'Postal',
    postalPlaceholder: '',
    message: 'ฝากข้อความ',
    messagePlaceholder: 'ถ้ามีอะไรอื่นๆกรุณากรอกฝากข้อความ',
    note: 'ข้อตกลงของผู้ใช้',
    confirm: 'ยืนยันการส่ง',


    // 订单结果页
    goback: 'คลิ๊กเพื่อกลับหน้าหลัก',
    kefu: 'ลูกค้าออนไลน์',
    success: 'สำเร็จ',
    orderTime: 'เวลาสั่งซื้อ',
    orderId: 'เลขที่ใบสั่งซื้อ',
    shouhuo: 'ข้อมูลที่รับสินค้า',
    packageNum: 'จำนวนชุดสินค้า',
    totalPrice: 'ยอดเงิน',
    yunfei: 'ค่าขนส่ง',
    shifu: 'ชำระเงิน',
    sevenDay: 'สินค้าเปลี่ยนหรือคืนได้',

    // 表单错误提示
    missingValue: 'โปรดเขียนสิ่งนี้',
    lengthError: 'โปรดใช้อย่างน้อย 8 ตัวอักษร',
    mismatch: 'โปรดระบุรูปแบบที่ถูกต้อง',
    numberMismatch: 'ใส่ตัวเลขเท่านั้น',

    // 提交太频繁
    'too fast': 'ส่งเร็วเกินไปโปรดลองอีกครั้งในภายหลัง'
}

// 货币单位
const unitConfig = {
    '台湾': 'NT$',
    '香港': 'HK$',
    '泰国': '฿',
    '马来西亚': 'RM',
    '菲律宾': '₱',
    '新加坡': 'S$'
}

// 省信息
const provinceStrs = {
    '泰国': 'ไทย',
    '香港': 'Hongkong',
    '马来西亚': 'Malaysia',
    '菲律宾': 'Philippines',
    '新加坡': 'Singapore'
}


const locale = (area, language) => {
    let unit = unitConfig[(area || '台湾')]
    let provinceStr = provinceStrs[(area || '香港')]
    switch(language) {
        case '英语':
            return {...english, unit, provinceStr}
        case '泰语':
            return {...thai, unit, provinceStr}
        case '繁体中文':
            return {...chinese, unit, provinceStr}
        default:
            return {...chinese, unit, provinceStr}
    }
}


export default locale